
export const documentTitle = (pageTitle) => {
    return `Медиа: ${pageTitle} — Моды для Мир танков`
}